import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const MODULE_NAME = "today_pass_reset_pg MH"; // For event tracking

const today = new Date();
const activeDate = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear().toString().slice(0, 2)}`;
const screen = "today_pass_reset_pg MH";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const PasswordResetPage = (props) => {
    const query = useQuery();
    const initialToken = query.get("token") || "";
    const [newPassword, setNewPassword] = useState("");
    const [token, setToken] = useState(initialToken);
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showTokenError, setShowTokenError] = useState(false);

    // Email request state (for requesting a reset link)
    const [showRequestForm, setShowRequestForm] = useState(false);
    const [requestEmail, setRequestEmail] = useState("");
    const [requestLoading, setRequestLoading] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [requestError, setRequestError] = useState("");

    useEffect(() => {
        setToken(initialToken);
        setShowTokenError(!initialToken);
    }, [initialToken]);

    // Submit new password with token
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        setSuccess(null);

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/password-reset/confirm`, {
                token: token.trim(),
                new_password: newPassword.trim()
            });
            setSuccess(res.data.success);
            setMessage(res.data.message || (res.data.success ? "Password reset successful." : "Password reset failed."));
        } catch (err) {
            setSuccess(false);
            setMessage(
                err.response?.data?.message ||
                "Error connecting to server."
            );
        }
        setLoading(false);
    };

    // Request password reset link
    const handleRequestSubmit = async (e) => {
        e.preventDefault();
        setRequestLoading(true);
        setRequestMessage("");
        setRequestError("");
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/password-reset`, {
                email: requestEmail.trim()
            });
            if (res.data.success) {
                setRequestMessage(res.data.message || "Password reset link sent to your email.");
                setRequestError("");
            } else {
                setRequestError(res.data.message || "Unable to send password reset link.");
                setRequestMessage("");
            }
        } catch (err) {
            setRequestError(
                err.response?.data?.message ||
                "Unable to send password reset link. Please try again."
            );
            setRequestMessage("");
        }
        setRequestLoading(false);
    };

    // Toggle between request form and reset form
    const handleShowRequestForm = (e) => {
        e.preventDefault();
        setShowRequestForm(true);
        setRequestMessage("");
        setRequestError("");
        setRequestEmail("");
    };

    const handleHideRequestForm = (e) => {
        e.preventDefault();
        setShowRequestForm(false);
        setRequestMessage("");
        setRequestError("");
        setRequestEmail("");
    };

    return (
        <div className="_login-page" data-analytics={MODULE_NAME}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                <a href="https://www.tontradingtools.com" rel="noopener noreferrer">
                    <img
                        src="images/logo/logo.png"
                        alt="Logo"
                        style={{
                            height: "40px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            marginRight: "16px"
                        }}
                    />
                </a>
            </div>
            {!showRequestForm ? (
                <form
                    className="_login-form"
                    style={{
                        maxWidth: "400px",
                        margin: "0 auto",
                        padding: "24px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                        background: "#fff"
                    }}
                    onSubmit={handleSubmit}
                >
                    <h2
                        style={{
                            textAlign: "center",
                            marginBottom: "16px",
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontWeight: "bold",
                            fontSize: "2rem",
                            color: "#1976d2"
                        }}
                    >
                        Password Reset
                    </h2>
                    {showTokenError ? (
                        <div style={{ color: "red", textAlign: "center", marginBottom: "16px" }}>
                            Error: Reset token missing. Please use the link from your email.
                            <div style={{ marginTop: "12px" }}>
                                <a
                                    href="#request"
                                    onClick={handleShowRequestForm}
                                    style={{ color: "#457b9d", textDecoration: "underline", cursor: "pointer", fontSize: 15 }}
                                >
                                    Request password reset link
                                </a>
                            </div>
                            <div style={{ marginTop: "12px" }}>
                                <a
                                    href="https://pro.tontradingtools.com"
                                    style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontSize: 15 }}
                                >
                                    Back to login
                                </a>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div style={{ marginBottom: "16px" }}>
                                <label htmlFor="token" style={{ display: "block", marginBottom: "4px" }}>Reset Token</label>
                                <input
                                    id="token"
                                    type="text"
                                    value={token}
                                    readOnly
                                    style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", background: "#f5f5f5" }}
                                />
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                                <label htmlFor="newPassword" style={{ display: "block", marginBottom: "4px" }}>New Password</label>
                                <input
                                    id="newPassword"
                                    type="password"
                                    value={newPassword}
                                    onChange={e => setNewPassword(e.target.value)}
                                    placeholder="Enter new password"
                                    style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "4px",
                                    background: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    fontWeight: "bold",
                                    cursor: loading ? "not-allowed" : "pointer"
                                }}
                            >
                                {loading ? "Resetting..." : "Reset Password"}
                            </button>
                            <div style={{ textAlign: "center", marginTop: "18px" }}>
                                <a
                                    href="/auth?screen=login"
                                    style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontSize: 15 }}
                                >
                                    Back to login
                                </a>
                            </div>
                        </>
                    )}
                    {message && (
                        <div
                            style={{
                                marginTop: "16px",
                                color: success ? "green" : "red",
                                textAlign: "center"
                            }}
                        >
                            {message}
                        </div>
                    )}
                </form>
            ) : (
                <form
                    className="_login-form"
                    style={{
                        maxWidth: "400px",
                        margin: "0 auto",
                        padding: "24px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                        background: "#fff"
                    }}
                    onSubmit={handleRequestSubmit}
                >
                    <h2
                        style={{
                            textAlign: "center",
                            marginBottom: "16px",
                            fontFamily: "Arial, Helvetica, sans-serif",
                            fontWeight: "bold",
                            fontSize: "2rem",
                            color: "#1976d2"
                        }}
                    >
                        Request Password Reset
                    </h2>
                    <div style={{ marginBottom: "16px" }}>
                        <label htmlFor="requestEmail" style={{ display: "block", marginBottom: "4px" }}>Email</label>
                        <input
                            id="requestEmail"
                            type="email"
                            value={requestEmail}
                            onChange={e => setRequestEmail(e.target.value)}
                            placeholder="Enter your email"
                            style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
                            required
                        />
                    </div>
                    {requestError && (
                        <div style={{ color: "#e63946", marginBottom: 8 }}>{requestError}</div>
                    )}
                    {requestMessage && (
                        <div style={{ color: "#228B22", marginBottom: 8 }}>{requestMessage}</div>
                    )}
                    <button
                        type="submit"
                        disabled={requestLoading}
                        style={{
                            width: "100%",
                            padding: "10px",
                            borderRadius: "4px",
                            background: "#1976d2",
                            color: "#fff",
                            border: "none",
                            fontWeight: "bold",
                            cursor: requestLoading ? "not-allowed" : "pointer"
                        }}
                    >
                        {requestLoading ? "Sending..." : "Send Reset Link"}
                    </button>
                    <div style={{ textAlign: "center", marginTop: "14px" }}>
                        <a
                            href="/auth?screen=login"
                            style={{ color: "#1976d2", textDecoration: "underline", cursor: "pointer", fontSize: 15 }}
                        >
                            Back to login
                        </a>
                    </div>
                </form>
            )}
        </div>
    );
};

export default PasswordResetPage;